import { render, staticRenderFns } from "./openData.vue?vue&type=template&id=1ebfb7e0&scoped=true"
import script from "./openData.vue?vue&type=script&lang=js"
export * from "./openData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebfb7e0",
  null
  
)

export default component.exports